/**
 * Centralized design tokens for consistent styling
 */
export const themeTokens = {
  borderRadius: {
    small: 8,
    medium: 12,
    large: 16,
    xlarge: 20,
  },
  shadows: {
    soft: '0px 2px 8px rgba(0, 0, 0, 0.08), 0px 4px 6px rgba(0, 0, 0, 0.10)',
    medium: '0px 4px 12px rgba(0, 0, 0, 0.10), 0px 2px 4px rgba(0, 0, 0, 0.08)',
    strong: '0px 8px 24px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08)',
  },
  transition: {
    default: 'all 0.2s ease-in-out',
    fast: 'all 0.15s ease-in-out',
    slow: 'all 0.3s ease-in-out',
  },
} as const;
